module.exports = __webpack_public_path__ + "nc_static/media/register-iot-disabled.d3af756e.svg";